import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    width: '40%',
    className: 'bold',
    render: (data, type, row, meta) => {
      var url = `/admin/dashboards/${row.DT_RowId}/overview`
      return renderToString(<a href={url}>{data}</a>)
    }
  },
  {
    data: 'target_count',
    width: '30%',
  },
  {
    data: 'completion_rate',
    width: '30%',
  }
]

const headers = ['Name', 'Number of people', 'Completion rate']

const filters = []

const sorters = [
  { column: 0, label: 'Name', order: 'asc' },
  { column: 1, label: 'Number of people', order: 'desc' },
  { column: 2, label: 'Completion rate', order: 'desc' },
]

const order = [[0, "asc"]]

export { columns, headers, filters, sorters, order }
